const getNews = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getNews/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedNews = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedNews/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getLocalisedNewsByParentId = async (language_code, parent_id) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getLocalisedNewsByParentId/${language_code}/${parent_id}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      //console.log("json response: ", json);
      if (json.code === 404) {
        throw new Error("404: File not found");
      }
      return json;
    })
    .catch((error) => {
      throw error;
    });
};

// const getNewsLatest = async (language_code, category = "news") => {
//   return await fetch(
//     `https://us-central1-zefi-cms.cloudfunctions.net/getNewsLatest/${language_code}`,
//     { method: "GET" }
//   )
//     .then((res) => res.json())
//     .then((json) => json)
//     .catch((error) => {
//       console.log(error);
//     });
// };
//New news seciton api
const getNewsLatest = async (language_code) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getNewsMedia/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

const getNewsBySlug = async (language_code, slug) => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getNewsBySlug/${language_code}/${slug}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      // console.log("getAcademyMedia(): ", json);
      return json;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

export {
  getNews,
  getLocalisedNews,
  getLocalisedNewsByParentId,
  getNewsLatest,
  getNewsBySlug,
};
